import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import Game from './components/Game.js';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(<Game/>);

